<template>
    <div class="frmlogin_cont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <GrcText ref="txtEmailCim" v-model="txtEmailCim" 
        grc_labeltext="E-mail cím:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="100px" 
        v-on:grc-keydown-enter="SetControlToFocus('txtJelszo');"
        style="margin-bottom:20px;"
        />

        <GrcText ref="txtJelszo" v-model="txtJelszo" 
        grc_ispassword="true"
        grc_labeltext="Jelszó:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="100px" 
        v-on:grc-keydown-enter="SetControlToFocus('btnLogin');"
        style="margin-bottom:20px;"
        grc_canshowpassword="mobilapp"
        />

        <table style="width:100%; margin-bottom:30px;" cellspacing="0" cellpadding="0">
        <tr>
            <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkStoreEmail" /></td>
            <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:14px; line-height:18px; color:#222;" v-html="txtStoreEmail">
            </td>
        </tr>
        </table>

        <div class="frmlogin_btncont">
            <GrcButton ref="btnLogin" @grc-click="btnLogin_click"
            grc_text="Bejelentkezés" grc_readonly="false" 
            grc_style="frmlogin_button_ok"
             />                    
        </div>


    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'frmlogin',
  components: {
      GrcText,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmlogin_",

          txtEmailCim: "",
          txtJelszo: "",

          txtStoreEmail: "",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmlogin", pCompName);
    },

    SetLang()
    {
        this.$refs.txtEmailCim.SetLabel(this.GetTextBookItem("txtEmailCim"));
        this.$refs.txtJelszo.SetLabel(this.GetTextBookItem("txtJelszo"));
        this.$refs.btnLogin.SetLabel(this.GetTextBookItem("btnLogin"));
        this.txtStoreEmail = this.GetTextBookItem("txtStoreEmail");


        this.$refs.txtEmailCim.HideError();
        this.$refs.txtJelszo.HideError();

        if (GRCAPP_MAILREM == "")
        {
          //this.SetControlToFocus("txtEmailCim");
        }
        else
        {
          //this.SetControlToFocus("txtJelszo");
        }

    },

    btnRegisztracio_click()
    {
      this.$emit("navigate","regisztracio");
    },

    ElfelejtettJelszo_click()
    {
      this.$emit("navigate","elfelejtett_jelszo");
    },


      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      btnLogin_click()
      {
          this.Login();
      },

      async Login()
      {
        gXLMS = "";
        
        var ErrorCompName = "";
        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }

        if (this.$refs.txtJelszo.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtJelszo"; }
          this.$refs.txtJelszo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }



        this.$refs.GRCDB.ShowLoading(false);

        // szerver oldali CSS beállítások böngészőhöz optimalizálása érdekében
        var pAgent = grcmain_GetAgent()+": "+navigator.userAgent;
        if (typeof pAgent == "undefined") { pAgent = "unknown"; }


        var QP = { 
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            sJelszo: this.$refs.txtJelszo.GetText(),
            sIPAddress: "[IPADDRESS]",
            sBrowserAgent: pAgent,
            iRememberMail: this.$refs.chkStoreEmail.GetValue()

        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "login", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.$emit("handlecommerror", Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        document.cookie = "XLMS=; Secure";
        
        if (Q.LOGINRESULT[0].intResult != 1)
        {
            this.$refs.txtEmailCim.ShowError(Q.LOGINRESULT[0].strResult);
            this.SetControlToFocus("txtEmailCim");

            return;
        }

        /*
        GRCAPP_MAILREM = "";
        var emailrem = "";
        emailrem = ""+this.$refs.chkStoreEmail.GetValue()+";";
        if (this.$refs.chkStoreEmail.GetValue() == 1)
        {
          emailrem = emailrem + this.$refs.txtEmailCim.GetText();
          GRCAPP_MAILREM = this.$refs.txtEmailCim.GetText();
        }
        else { emailrem = emailrem + "no"; }

        this.$emit("emailremember", emailrem);
        */
        
        document.location = Q.LOGINRESULT[0].RedirUrl;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
        this.SetControlToFocus("txtEmailCim");
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();

    if (gAppInitDone)
    {
      if (grcmain_GetAppTypeID() != 0)
      {
        gRouteMode = "replace";
        this.$emit("navigate", "default");
      }
    }

    this.$refs.txtEmailCim.SetText(GRCAPP_MAILREM);
    if (GRCAPP_MAILREM != "")
    {
      this.$refs.chkStoreEmail.SetValue(1);
    }
    
    //this.SetControlToFocus("txtEmailCim");      
  }

}


</script>


